import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPremiumsExportSplits = options =>
  call(websocketFetch, 'get_premiums_export_splits', options);
